import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ListItem } from '@lmnop/web-core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'select-extended-control',
    templateUrl: 'select-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class SelectExtendedControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() controlName!: string;
    @Input() showIcon: boolean = true;
    @Input() iconClass: string = 'fas fa-align-justify';
    @Input() labelText: string;
    @Input() optionList: ListItem[] = [];
    @Input() shouldTranslateOptions: boolean = true;

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };

    @Output() selectionChange = new EventEmitter<any>();

    onChange(event: Event) {
        const value = (event.target as HTMLSelectElement).value;
        this.selectionChange.emit(value);
    }
}
